export const GET_LIST_PAGINATION = "GET_LIST_PAGINATION"
